"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subdomains = exports.letsshineksaSubdomain = exports.onvuLearningSubdomain = exports.bitdefenderSubdomain = exports.foundationForHealthyStPetesburgSubdomain = exports.himssSubdomain = exports.diverseForceSubdomain = exports.openweaverSubdomain = exports.carahSoftSubdomain = exports.nationalBlackLawyersSubdomain = exports.nationalTrialLawyersSubdomain = exports.storyIqSubdomain = exports.philipMorrisSubdomain = void 0;
// Sample Credential No's
exports.philipMorrisSubdomain = "philip-morris";
// philip-morris 52252422127528
exports.storyIqSubdomain = "storyiq";
// storyiq 39157371000589
exports.nationalTrialLawyersSubdomain = "the-national-trial-lawyers";
// the-national-trial-lawyers 06305115959792
exports.nationalBlackLawyersSubdomain = "national-black-lawyers";
// national-black-lawyers 27108830874044
exports.carahSoftSubdomain = "carahsoft";
// carahsoft 96346057363312
exports.openweaverSubdomain = "kandi";
// kandi 18561181049697
exports.diverseForceSubdomain = "diverseforce";
// diverseforce 71474715925007
exports.himssSubdomain = "himssorg";
// Foundation for a Healthy St. Petersburg
// foundation 34786488198777
exports.foundationForHealthyStPetesburgSubdomain = "foundation-for-a-healthy-st-pe";
// Bitdefender 86463315228841
exports.bitdefenderSubdomain = "bitdefender";
exports.onvuLearningSubdomain = "onvu-learning";
// aa-media-group 87222627453265
exports.letsshineksaSubdomain = "letsshineksa";
exports.Subdomains = {
    philipMorris: exports.philipMorrisSubdomain,
    storyIq: exports.storyIqSubdomain,
    nationalTrialLawyers: exports.nationalTrialLawyersSubdomain,
    nationalBlackLawyers: exports.nationalBlackLawyersSubdomain,
    carahSoft: exports.carahSoftSubdomain,
    openweaver: exports.openweaverSubdomain,
    diverseForce: exports.diverseForceSubdomain,
    himss: exports.himssSubdomain,
    foundationForHealthyStPetesburg: exports.foundationForHealthyStPetesburgSubdomain,
    bitdefender: exports.bitdefenderSubdomain,
    onvuLearning: exports.onvuLearningSubdomain,
    letsshineksa: exports.letsshineksaSubdomain,
};
